import styled from 'styled-components';

const UpdatedAtLabel = styled.label`
  font-size: var(--font-smallest);
  color: var(--default-gray);
`;

export { UpdatedAtLabel };
